export default "__VITE_ASSET__B4u2CTrn__"